// extracted by mini-css-extract-plugin
export default {"wrapper":"UserEditOverlay_wrapper__ADQT0","buttonWrapper":"UserEditOverlay_buttonWrapper__UTu19"};